import {
  Avatar,
  Box,
  ButtonBase,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { Loader } from 'Components';
import { useIsDesktop } from 'Hooks';
import { ACTIVITY_TYPE } from 'Enum/ActivitiesLobby';
import { PurpleDownloadIcon } from 'Images';
import { useState } from 'react';
import { IRelatedAction } from '..';

interface IRelatedActionItemProps {
  action: IRelatedAction;
  onClick: () => void;
}

export const RelatedActionItem = ({
  action,
  onClick,
}: IRelatedActionItemProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const isDesktop = useIsDesktop();
  const isDownload = action.activityTypeId === ACTIVITY_TYPE.FILE;
  const maxTitleLength = 26;

  const handleClick = async () => {
    setIsLoading(true);
    await onClick();
    setIsLoading(false);
  };

  return (
    <ButtonBase
      component={Paper}
      onClick={handleClick}
      aria-label={action.title}
      aria-busy={isLoading || undefined}
      title={action.title}
      focusRipple
      sx={{
        cursor: 'pointer',
        border: '1px solid',
        borderColor: '#BA71FF',
        borderRadius: '12px',
        backgroundColor: '#FFF',
        p: '12px 16px',
        boxShadow: 'none',
        width: isDesktop ? 175 : 'calc((100% - 10px) / 2)',
        minWidth: isDesktop ? 175 : 'calc((100% - 10px) / 2)',
        maxWidth: isDesktop ? 175 : 'calc((100% - 10px) / 2)',
        height: isDesktop ? 60 : 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '&.Mui-focusVisible': {
          outline: '3px solid #1552E8',
          outlineOffset: 2,
        },
      }}
    >
      <Typography
        maxWidth={'100%'}
        textAlign='center'
        variant='body6'
        sx={{ pointerEvents: 'none' }}
      >
        {action.title.length > maxTitleLength
          ? action.title.substring(0, maxTitleLength - 3) + '...'
          : action.title}
      </Typography>

      {isDownload &&
        (isLoading ? (
          <Box
            aria-live='polite'
            aria-label='Downloading…'
            sx={{
              width: 18,
              height: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ml: 1,
            }}
          >
            <Loader size={18} />
          </Box>
        ) : (
          <Stack
            direction='row'
            gap='4px'
            maxWidth='min-content'
            mr='8px'
            aria-hidden
          >
            <Avatar
              src={PurpleDownloadIcon}
              alt=''
              role='presentation'
              sx={{ width: 16, height: 16 }}
            />
          </Stack>
        ))}
    </ButtonBase>
  );
};
